var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-flex items-center px-2.5 py-0.5 rounded-md text-sm whitespace-nowrap font-bold",class:[_vm.colorClasses, {'uppercase': _vm.uppercase}]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }